import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Partners, Banner, Events, Mission, Process, PortfolioSection, Pricing, Products, MenuSection } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <PortfolioSection /> {/* Portfolio Section */}
      <Mission /> {/* Mission section */}
      <MenuSection /> {/* Menu Tabs Section */}
      <Process /> {/* Process Section */}
      <Banner /> {/* Banner Section */}
      <Events /> {/* Events Slider */}
      <Products /> {/* Popular Items */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <Pricing /> {/* Pricing Section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;